import React from 'react';
import {
  Achievements,
  Members,
  Ownership,
} from '@dewise-devex/backstage-plugin-product-frontend';
import { Grid } from '@dewise-devex/backstage-plugin-mui-uikit-react';

export const ProductPage: React.FC = () => {
  return (
    <>
      <Grid size={{ md: 4, xs: 12 }}>
        <Achievements />
      </Grid>
      <Grid size={{ md: 5, xs: 12 }}>
        <Ownership />
      </Grid>
      <Grid size={{ md: 3, xs: 12 }}>
        <Members />
      </Grid>
    </>
  );
};
